<template>
  <FieldBase
    :name="name"
    :label="label"
    :description="description"
    :sublabel="sublabel"
    :size="size"
    :loading="loading"
    :helper-message="helperMessage"
    :has-error="hasError"
    :error-message="errorMessage"
    :is-error-checked="isErrorChecked"
  >
    <template slot="field">
      <textarea
        :id="name"
        :value="value"
        :name="name"
        :placeholder="placeholder"
        :autofocus="autofocus"
        :disabled="disabled"
        class="c-field"
        :rows="rows"
        @input="input"
        @blur="$emit('blur')"
      />
    </template>
  </FieldBase>
</template>

<script>
import fieldBaseMixin from '../FieldBase/mixin'
export default {
  name: 'TextField',
  mixins: [fieldBaseMixin],
  props: {
    rows: {
      type: String,
      default: '4',
    },
  },
}
</script>
